const showMoreAccordianStrings = {
  display: {
    seeMore: 'Show more',
    seeLess: 'Show less',
  },
};

export default showMoreAccordianStrings;
